import { Injectable } from '@angular/core';

import icons from './icons';

export type IconType = keyof typeof icons;

@Injectable()
export class IconService {
  /**
   * Return the SVG content for an icon
   * @param name Name of the icon to get the SVG for
   */
  public getSvgForName(name: IconType): string {
    return (
      `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">` + icons[name] + `</svg>`
    );
  }
}
